import apiEndpoints from 'constants/apiEndpoints';
import Selector from 'components/custom/forms/Selector';
import useFetchData from 'hooks/custom/useFetchData';
import React, { useEffect, useState } from 'react';
import { generateOptions } from 'services/utils';
import { NewBranchBtn } from 'views/location/branch/CreateBranch';
import { useAuth } from 'hooks/auth/useAuth';

const BranchDropdown = () => {
  const { user } = useAuth();
  const [selectedBranch, setSelectedBranch] = useState('all');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [branchOption, setBranchOption, refreshBranchOption] = useFetchData(
    apiEndpoints.branch.getAll,
    {
      dataModifier: data => {
        return [
          {
            branch_id: 'all',
            city_name: '',
            country_name: '',
            branch_name: 'All Branch'
          },
          ...data
        ];
      }
    }
  );

  useEffect(() => {
    if (user.user_role !== 'Admin') {
      setSelectedBranch(user.branch_id);
    }
  }, [user.user_role]);
  return (
    <div>
      <Selector
        defaultSelect={selectedBranch}
        inputProps={{
          // disabled: user.user_role !== 'Admin'
          disabled: true
        }}
        dataSet={generateOptions({
          data: branchOption || [],
          formatter: option => ({
            label: option.branch_name,
            value: option.branch_id,
            disabled: option.change_flag === '1',
            desc:
              option.change_flag === '1' ? (
                <span className="text-warning">Need Approval</span>
              ) : (
                `${option.city_name || ''}${option.city_name ? ',' : ''} ${option.country_name || ''}`
              )
          })
        })}
        onChange={id => setSelectedBranch(id)}
        startIcon="uil:building"
        placeholder={'Select Branch'}
        allowFooter={true}
        footerTextBtn={(search, _, setSearch) => (
          <NewBranchBtn
            searchText={search}
            handleRefresh={refreshBranchOption}
            setFunction={data => {
              setSearch(data.name || '');
            }}
          />
        )}
      />
    </div>
  );
};

export default BranchDropdown;
